import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.6376 7.13349C10.93 6.84012 11.4049 6.83936 11.6982 7.13178L16.018 11.4376C16.1534 11.557 16.2455 11.7245 16.2674 11.9134C16.2709 11.943 16.2728 11.973 16.2727 12.0032C16.2727 12.2026 16.1932 12.3937 16.0519 12.5344L11.6979 16.8698C11.4044 17.162 10.9295 17.161 10.6373 16.8675C10.345 16.574 10.346 16.0991 10.6396 15.8068L13.709 12.7506H5C4.58579 12.7506 4.25 12.4148 4.25 12.0006C4.25 11.5864 4.58579 11.2506 5 11.2506H13.7056L10.6393 8.19415C10.3459 7.90173 10.3451 7.42685 10.6376 7.13349Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 5.98828C19.4142 5.98828 19.75 6.32407 19.75 6.73828V17.2635C19.75 17.6777 19.4142 18.0135 19 18.0135C18.5858 18.0135 18.25 17.6777 18.25 17.2635V6.73828C18.25 6.32407 18.5858 5.98828 19 5.98828Z",
		fill: "currentColor"
	})]
});
export default SvgRightLine;
